var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A6",
    fillRule: "nonzero",
    d: "M7.277 12.966l.973-.974a4 4 0 0 0 3.742-3.742l2.301-2.3c.425.431.841.91 1.25 1.437a1 1 0 0 1 0 1.226C13.273 11.538 10.76 13 8 13c-.243 0-.484-.011-.723-.034zm-5.57-2.915a16.31 16.31 0 0 1-1.25-1.438 1 1 0 0 1 0-1.226C2.727 4.462 5.24 3 8 3c.243 0 .484.011.723.034l-.973.974A4 4 0 0 0 4.008 7.75l-2.301 2.3zm11.586-8.758a1 1 0 0 1 1.414 1.414l-12 12a1 1 0 1 1-1.414-1.414l12-12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHidden);
export default __webpack_public_path__ + "static/media/eye-hidden.da952c9c2206217ab7b702d065cd2925.svg";
export { ForwardRef as ReactComponent };